"use client";

import { ReactNode } from "react";
import RegionalNav from "./RegionalNav";
import RegionalFooter from "./RegionalFooter";
import { RegionalAirportConfig } from "./types";

interface RegionalLayoutProps {
  config: RegionalAirportConfig;
  children: ReactNode;
}

export default function RegionalLayout({
  config,
  children,
}: RegionalLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <RegionalNav config={config} />
      <main className="flex-1">{children}</main>
      <RegionalFooter config={config} />
    </div>
  );
}
